// @generated by scripts/generate-protocol.mjs. Do not edit.
export const ABI_VERSION = 26;
export const MINIMUM_READABLE_ABI_VERSION = 4;
export const PROTOCOL_ALIGNMENT = 4;
export const STREAM_HEADER_BYTES = 16;
export const INSTRUCTION_HEADER_BYTES = 4;
export const INSTRUCTION_FLAG_OPTIONAL = 1;
export const INSTRUCTION_FLAG_MASK = 1;
export const INSTRUCTION_LENGTH_ESCAPE = 65535;
export const RECORD_HEADER_BYTES = 8;
export const NODE_ID_INDEX_BITS = 20;
export const NODE_ID_GENERATION_BITS = 12;
export const NULL_NODE_ID = 4294967295;
export const MUTATION_MAGIC = 1297108804;
export const INPUT_MAGIC = 1229999940;
export const DISPLAY_LIST_MAGIC = 1146113860;
export const GLYPH_RESOURCES_MAGIC = 1196445508;
export const SYSTEM_TEXT_METRICS_MAGIC = 1414549316;
export const RECORDING_MAGIC = 1380994884;
export const MAX_MUTATION_BYTES = 16777216;
export const MAX_INPUT_BYTES = 16777216;
export const MAX_DISPLAY_LIST_BYTES = 33554432;
export const MAX_GLYPH_RESOURCES_BYTES = 16777216;
export const MAX_SYSTEM_TEXT_METRICS_BYTES = 8388608;
export const MAX_RECORDING_BYTES = 67108864;
export const MAX_RESOURCE_BYTES = 8388608;
export const MAX_MUTATION_INSTRUCTIONS = 262144;
export const MAX_INPUT_INSTRUCTIONS = 262144;
export const MAX_DISPLAY_INSTRUCTIONS = 1048576;
export const MAX_GLYPH_RESOURCE_INSTRUCTIONS = 262144;
export const MAX_SYSTEM_TEXT_METRIC_INSTRUCTIONS = 262144;
export const MAX_GLYPH_BITMAP_PIXELS = 16777216;
export const MAX_SYSTEM_TEXT_LINES = 1048576;
export const MAX_SYSTEM_TEXT_ADVANCES = 1048576;
export const MAX_WORD_BOUNDARIES = 262144;
export const MAX_RECORDING_RECORDS = 1048576;
export const MAX_VIRTUAL_ITEMS = 4000000;
export const MAX_STYLED_RUNS = 65536;
export const MAX_EDIT_MARK_RUNS = 65536;
export const MAX_EDIT_MAP_SEGMENTS = 65536;
export const MAX_DOCUMENT_BLOCK_KEYS = 65536;
export const VIRTUAL_REFILL_VERSION = 1;
export const VIRTUAL_REFILL_HEADER_WORDS = 2;
export const VIRTUAL_REFILL_RECORD_WORDS = 3;
export const VIRTUAL_REFILL_HEADER_VERSION_INDEX = 0;
export const VIRTUAL_REFILL_HEADER_REQUEST_COUNT_INDEX = 1;
export const VIRTUAL_REFILL_RECORD_NODE_ID_INDEX = 0;
export const VIRTUAL_REFILL_RECORD_START_INDEX = 1;
export const VIRTUAL_REFILL_RECORD_END_INDEX = 2;
export const GLYPH_BITMAP_FIXED_BYTES = null;
export const GLYPH_BITMAP_MINIMUM_BYTES = 28;
export const GLYPH_BITMAP_GLYPH_ID_OFFSET = 0;
export const GLYPH_BITMAP_LEFT_OFFSET = 4;
export const GLYPH_BITMAP_TOP_OFFSET = 8;
export const GLYPH_BITMAP_WIDTH_OFFSET = 12;
export const GLYPH_BITMAP_HEIGHT_OFFSET = 16;
export const GLYPH_BITMAP_DEVICE_PIXEL_RATIO_OFFSET = 20;
export const GLYPH_BITMAP_DATA_BYTES_OFFSET = 24;
export const GLYPH_BITMAP_DATA_OFFSET = 28;
export const GLYPH_PLACEMENT_FIXED_BYTES = 12;
export const GLYPH_PLACEMENT_MINIMUM_BYTES = 12;
export const GLYPH_PLACEMENT_BITMAP_INDEX_OFFSET = 0;
export const GLYPH_PLACEMENT_X_OFFSET = 4;
export const GLYPH_PLACEMENT_Y_OFFSET = 8;
export const DOCUMENT_BLOCK_FIXED_BYTES = 16;
export const DOCUMENT_BLOCK_MINIMUM_BYTES = 16;
export const DOCUMENT_BLOCK_KEY_OFFSET = 0;
export const DOCUMENT_BLOCK_NODE_ID_OFFSET = 4;
export const DOCUMENT_BLOCK_LEN_UTF16_OFFSET = 8;
export const DOCUMENT_BLOCK_FLAGS_OFFSET = 12;
export const DOCUMENT_BLOCK_FLAG_ATOMIC = 1;
export const STYLED_RUN_FIXED_BYTES = 24;
export const STYLED_RUN_MINIMUM_BYTES = 24;
export const STYLED_RUN_UTF8_START_OFFSET = 0;
export const STYLED_RUN_UTF8_LENGTH_OFFSET = 4;
export const STYLED_RUN_STYLE_ID_OFFSET = 8;
export const STYLED_RUN_FONT_ID_OFFSET = 12;
export const STYLED_RUN_FLAGS_OFFSET = 16;
export const STYLED_RUN_RESERVED_OFFSET = 20;
export const EDIT_MARK_RUN_FIXED_BYTES = 12;
export const EDIT_MARK_RUN_MINIMUM_BYTES = 12;
export const EDIT_MARK_RUN_LENGTH_OFFSET = 0;
export const EDIT_MARK_RUN_STYLE_OFFSET = 4;
export const EDIT_MARK_RUN_FONT_OFFSET = 8;
export const EDIT_MAP_SEGMENT_FIXED_BYTES = 20;
export const EDIT_MAP_SEGMENT_MINIMUM_BYTES = 20;
export const EDIT_MAP_SEGMENT_OLD_START_OFFSET = 0;
export const EDIT_MAP_SEGMENT_OLD_END_OFFSET = 4;
export const EDIT_MAP_SEGMENT_NEW_START_OFFSET = 8;
export const EDIT_MAP_SEGMENT_NEW_END_OFFSET = 12;
export const EDIT_MAP_SEGMENT_FLAGS_OFFSET = 16;
export const EDIT_MAP_SEGMENT_FLAG_KEPT = 1;
export const STYLED_RUN_FLAG_ATOMIC = 1;
export const FRAME_DIAGNOSTICS_VERSION = 11;
export const FRAME_DIAGNOSTICS_WORDS = 47;
export const FRAME_DIAGNOSTICS_VERSION_INDEX = 0;
export const FRAME_DIAGNOSTICS_FRAME_SEQ_INDEX = 1;
export const FRAME_DIAGNOSTICS_SCENE_NODES_INDEX = 2;
export const FRAME_DIAGNOSTICS_DIRTY_LAYOUT_NODES_INDEX = 3;
export const FRAME_DIAGNOSTICS_DIRTY_PAINT_NODES_INDEX = 4;
export const FRAME_DIAGNOSTICS_DIRTY_PAINT_SELF_NODES_INDEX = 5;
export const FRAME_DIAGNOSTICS_DIRTY_HIT_NODES_INDEX = 6;
export const FRAME_DIAGNOSTICS_DIRTY_SEMANTICS_NODES_INDEX = 7;
export const FRAME_DIAGNOSTICS_LAYOUT_CHANGED_NODES_INDEX = 8;
export const FRAME_DIAGNOSTICS_LAYOUT_VISITED_NODES_INDEX = 9;
export const FRAME_DIAGNOSTICS_DISPLAY_COMMANDS_INDEX = 10;
export const FRAME_DIAGNOSTICS_PAINT_REBUILT_INDEX = 11;
export const FRAME_DIAGNOSTICS_PICTURE_BUILDS_INDEX = 12;
export const FRAME_DIAGNOSTICS_PICTURE_CACHE_HITS_INDEX = 13;
export const FRAME_DIAGNOSTICS_PICTURE_SUBTREE_BUILDS_INDEX = 14;
export const FRAME_DIAGNOSTICS_PICTURE_SUBTREE_CACHE_HITS_INDEX = 15;
export const FRAME_DIAGNOSTICS_OVER_INVALIDATED_FRAMES_INDEX = 16;
export const FRAME_DIAGNOSTICS_PICTURE_HASH_LOW_INDEX = 17;
export const FRAME_DIAGNOSTICS_PICTURE_HASH_HIGH_INDEX = 18;
export const FRAME_DIAGNOSTICS_VISIBLE_PLACEHOLDERS_INDEX = 19;
export const FRAME_DIAGNOSTICS_VIRTUAL_VISIBLE_START_INDEX = 20;
export const FRAME_DIAGNOSTICS_VIRTUAL_VISIBLE_END_INDEX = 21;
export const FRAME_DIAGNOSTICS_VIRTUAL_MATERIALIZED_START_INDEX = 22;
export const FRAME_DIAGNOSTICS_VIRTUAL_MATERIALIZED_END_INDEX = 23;
export const FRAME_DIAGNOSTICS_SKIPPED_INSTRUCTIONS_INDEX = 24;
export const FRAME_DIAGNOSTICS_PRODUCER_ABI_VERSION_INDEX = 25;
export const FRAME_DIAGNOSTICS_INTERACTION_STATE_CHANGES_INDEX = 26;
export const FRAME_DIAGNOSTICS_ANIMATION_ACTIVE_INDEX = 27;
export const FRAME_DIAGNOSTICS_ANIMATION_PHASE_BEFORE_INDEX = 28;
export const FRAME_DIAGNOSTICS_ANIMATION_PHASE_ACTIVE_INDEX = 29;
export const FRAME_DIAGNOSTICS_ANIMATION_PHASE_AFTER_INDEX = 30;
export const FRAME_DIAGNOSTICS_ANIMATION_STARTS_INDEX = 31;
export const FRAME_DIAGNOSTICS_ANIMATION_RETARGETS_INDEX = 32;
export const FRAME_DIAGNOSTICS_ANIMATION_CANCELS_INDEX = 33;
export const FRAME_DIAGNOSTICS_ANIMATION_SAMPLED_FRAMES_INDEX = 34;
export const FRAME_DIAGNOSTICS_ANIMATION_PRESENTATION_CHANGES_INDEX = 35;
export const FRAME_DIAGNOSTICS_ANIMATION_LAYOUT_NODES_INDEX = 36;
export const FRAME_DIAGNOSTICS_ANIMATION_RETAINED_BYTES_INDEX = 37;
export const FRAME_DIAGNOSTICS_PICTURE_DEFINES_INDEX = 38;
export const FRAME_DIAGNOSTICS_PICTURE_RELEASES_INDEX = 39;
export const FRAME_DIAGNOSTICS_PICTURE_RESIDENT_COUNT_INDEX = 40;
export const FRAME_DIAGNOSTICS_PICTURE_RESIDENT_BYTES_INDEX = 41;
export const FRAME_DIAGNOSTICS_PICTURE_RESOURCE_BYTES_INDEX = 42;
export const FRAME_DIAGNOSTICS_PICTURE_BUDGET_FALLBACKS_INDEX = 43;
export const FRAME_DIAGNOSTICS_OBSERVE_GEOMETRY_REJECTED_INDEX = 44;
export const FRAME_DIAGNOSTICS_DOCUMENT_STRUCTURE_REQUESTS_INDEX = 45;
export const FRAME_DIAGNOSTICS_DOCUMENT_CORRECTIONS_INDEX = 46;
export const RESOURCE_ENCODING_VERSION = 1;
export const SOLID_PAINT_RESOURCE_VARIANT = 1;
export const SOLID_PAINT_RESOURCE_FIXED_BYTES = 8;
export const SOLID_PAINT_RESOURCE_MINIMUM_BYTES = 8;
export const SOLID_PAINT_VERSION_OFFSET = 0;
export const SOLID_PAINT_VARIANT_OFFSET = 1;
export const SOLID_PAINT_RED_OFFSET = 4;
export const SOLID_PAINT_GREEN_OFFSET = 5;
export const SOLID_PAINT_BLUE_OFFSET = 6;
export const SOLID_PAINT_ALPHA_OFFSET = 7;
export const TEXT_STYLE_RESOURCE_VARIANT = 1;
export const TEXT_STYLE_RESOURCE_FIXED_BYTES = null;
export const TEXT_STYLE_RESOURCE_MINIMUM_BYTES = 24;
export const TEXT_STYLE_VERSION_OFFSET = 0;
export const TEXT_STYLE_VARIANT_OFFSET = 1;
export const TEXT_STYLE_PAINT_ID_OFFSET = 4;
export const TEXT_STYLE_FONT_SIZE_OFFSET = 8;
export const TEXT_STYLE_LINE_HEIGHT_OFFSET = 12;
export const TEXT_STYLE_WEIGHT_OFFSET = 16;
export const TEXT_STYLE_FAMILY_BYTES_OFFSET = 20;
export const TEXT_STYLE_FAMILY_OFFSET = 24;
export const TEXT_STYLE_V2_RESOURCE_VARIANT = 2;
export const TEXT_STYLE_V2_RESOURCE_FIXED_BYTES = null;
export const TEXT_STYLE_V2_RESOURCE_MINIMUM_BYTES = 28;
export const TEXT_STYLE_V2_VERSION_OFFSET = 0;
export const TEXT_STYLE_V2_VARIANT_OFFSET = 1;
export const TEXT_STYLE_V2_FONT_STYLE_OFFSET = 2;
export const TEXT_STYLE_V2_TEXT_ALIGN_OFFSET = 3;
export const TEXT_STYLE_V2_PAINT_ID_OFFSET = 4;
export const TEXT_STYLE_V2_FONT_SIZE_OFFSET = 8;
export const TEXT_STYLE_V2_LINE_HEIGHT_OFFSET = 12;
export const TEXT_STYLE_V2_WEIGHT_OFFSET = 16;
export const TEXT_STYLE_V2_WHITE_SPACE_OFFSET = 18;
export const TEXT_STYLE_V2_OVERFLOW_WRAP_OFFSET = 19;
export const TEXT_STYLE_V2_TEXT_OVERFLOW_OFFSET = 20;
export const TEXT_STYLE_V2_RESERVED_OFFSET = 21;
export const TEXT_STYLE_V2_FAMILY_BYTES_OFFSET = 24;
export const TEXT_STYLE_V2_FAMILY_OFFSET = 28;
export const SFNT_FONT_RESOURCE_VARIANT = 1;
export const SFNT_FONT_RESOURCE_FIXED_BYTES = null;
export const SFNT_FONT_RESOURCE_MINIMUM_BYTES = 12;
export const SFNT_FONT_VERSION_OFFSET = 0;
export const SFNT_FONT_VARIANT_OFFSET = 1;
export const SFNT_FONT_FACE_INDEX_OFFSET = 4;
export const SFNT_FONT_DATA_BYTES_OFFSET = 8;
export const SFNT_FONT_DATA_OFFSET = 12;
export const PATH_RESOURCE_VARIANT = 1;
export const PATH_RESOURCE_FIXED_BYTES = null;
export const PATH_RESOURCE_MINIMUM_BYTES = 28;
export const PATH_VERSION_OFFSET = 0;
export const PATH_VARIANT_OFFSET = 1;
export const PATH_FILL_RULE_OFFSET = 2;
export const PATH_RESERVED_OFFSET = 3;
export const PATH_VERB_COUNT_OFFSET = 4;
export const PATH_POINT_COUNT_OFFSET = 8;
export const PATH_VIEW_BOX_X_OFFSET = 12;
export const PATH_VIEW_BOX_Y_OFFSET = 16;
export const PATH_VIEW_BOX_WIDTH_OFFSET = 20;
export const PATH_VIEW_BOX_HEIGHT_OFFSET = 24;
export const PATH_PAYLOAD_OFFSET = 28;
export const AFFINE_RESOURCE_VARIANT = 1;
export const AFFINE_RESOURCE_FIXED_BYTES = 28;
export const AFFINE_RESOURCE_MINIMUM_BYTES = 28;
export const AFFINE_VERSION_OFFSET = 0;
export const AFFINE_VARIANT_OFFSET = 1;
export const AFFINE_A_OFFSET = 4;
export const AFFINE_B_OFFSET = 8;
export const AFFINE_C_OFFSET = 12;
export const AFFINE_D_OFFSET = 16;
export const AFFINE_E_OFFSET = 20;
export const AFFINE_F_OFFSET = 24;
export const IMAGE_BITMAP_RESOURCE_VARIANT = 1;
export const IMAGE_BITMAP_RESOURCE_FIXED_BYTES = null;
export const IMAGE_BITMAP_RESOURCE_MINIMUM_BYTES = 16;
export const IMAGE_BITMAP_VERSION_OFFSET = 0;
export const IMAGE_BITMAP_VARIANT_OFFSET = 1;
export const IMAGE_BITMAP_WIDTH_OFFSET = 4;
export const IMAGE_BITMAP_HEIGHT_OFFSET = 8;
export const IMAGE_BITMAP_PIXEL_BYTES_OFFSET = 12;
export const IMAGE_BITMAP_PIXELS_OFFSET = 16;
export const VIDEO_FRAME_RESOURCE_VARIANT = 1;
export const VIDEO_FRAME_RESOURCE_FIXED_BYTES = null;
export const VIDEO_FRAME_RESOURCE_MINIMUM_BYTES = 16;
export const VIDEO_FRAME_VERSION_OFFSET = 0;
export const VIDEO_FRAME_VARIANT_OFFSET = 1;
export const VIDEO_FRAME_WIDTH_OFFSET = 4;
export const VIDEO_FRAME_HEIGHT_OFFSET = 8;
export const VIDEO_FRAME_POSTER_PIXEL_BYTES_OFFSET = 12;
export const VIDEO_FRAME_POSTER_PIXELS_OFFSET = 16;
export const COMPUTED_STYLE_RESOURCE_VARIANT = 1;
export const COMPUTED_STYLE_RESOURCE_FIXED_BYTES = null;
export const COMPUTED_STYLE_RESOURCE_MINIMUM_BYTES = 16;
export const COMPUTED_STYLE_VERSION_OFFSET = 0;
export const COMPUTED_STYLE_VARIANT_OFFSET = 1;
export const COMPUTED_STYLE_FEATURE_BITS_OFFSET = 4;
export const COMPUTED_STYLE_ENTRY_COUNT_OFFSET = 8;
export const COMPUTED_STYLE_PAYLOAD_BYTES_OFFSET = 12;
export const COMPUTED_STYLE_PAYLOAD_OFFSET = 16;
export const STYLED_RUNS_RESOURCE_VARIANT = 1;
export const STYLED_RUNS_RESOURCE_FIXED_BYTES = null;
export const STYLED_RUNS_RESOURCE_MINIMUM_BYTES = 8;
export const STYLED_RUNS_VERSION_OFFSET = 0;
export const STYLED_RUNS_VARIANT_OFFSET = 1;
export const STYLED_RUNS_RUN_COUNT_OFFSET = 4;
export const STYLED_RUNS_RUNS_OFFSET = 8;
export var RecordingRecordKind;
(function (RecordingRecordKind) {
    RecordingRecordKind[RecordingRecordKind["Mutation"] = 1] = "Mutation";
    RecordingRecordKind[RecordingRecordKind["Input"] = 2] = "Input";
    RecordingRecordKind[RecordingRecordKind["SystemTextMetrics"] = 3] = "SystemTextMetrics";
    RecordingRecordKind[RecordingRecordKind["AnimationFrame"] = 4] = "AnimationFrame";
})(RecordingRecordKind || (RecordingRecordKind = {}));
export var VirtualAxis;
(function (VirtualAxis) {
    VirtualAxis[VirtualAxis["X"] = 0] = "X";
    VirtualAxis[VirtualAxis["Y"] = 1] = "Y";
})(VirtualAxis || (VirtualAxis = {}));
export var MutationOpcode;
(function (MutationOpcode) {
    MutationOpcode[MutationOpcode["CreateNode"] = 1] = "CreateNode";
    MutationOpcode[MutationOpcode["RemoveNode"] = 2] = "RemoveNode";
    MutationOpcode[MutationOpcode["Reparent"] = 3] = "Reparent";
    MutationOpcode[MutationOpcode["SetF32"] = 16] = "SetF32";
    MutationOpcode[MutationOpcode["SetVec4"] = 17] = "SetVec4";
    MutationOpcode[MutationOpcode["SetRef"] = 18] = "SetRef";
    MutationOpcode[MutationOpcode["SetFlags"] = 19] = "SetFlags";
    MutationOpcode[MutationOpcode["ClearProp"] = 20] = "ClearProp";
    MutationOpcode[MutationOpcode["SetTextRun"] = 32] = "SetTextRun";
    MutationOpcode[MutationOpcode["SetRichText"] = 33] = "SetRichText";
    MutationOpcode[MutationOpcode["DefineResource"] = 48] = "DefineResource";
    MutationOpcode[MutationOpcode["ReleaseResource"] = 49] = "ReleaseResource";
    MutationOpcode[MutationOpcode["ScrollTo"] = 64] = "ScrollTo";
    MutationOpcode[MutationOpcode["ConfigureVirtualList"] = 65] = "ConfigureVirtualList";
    MutationOpcode[MutationOpcode["SetVirtualItem"] = 66] = "SetVirtualItem";
    MutationOpcode[MutationOpcode["ConfigureEditable"] = 80] = "ConfigureEditable";
    MutationOpcode[MutationOpcode["ConfigureDocument"] = 97] = "ConfigureDocument";
    MutationOpcode[MutationOpcode["ObserveGeometry"] = 96] = "ObserveGeometry";
    MutationOpcode[MutationOpcode["Commit"] = 240] = "Commit";
})(MutationOpcode || (MutationOpcode = {}));
export const MUTATION_LAYOUTS = {
    [MutationOpcode.CreateNode]: { fixedBytes: 20, minimumBytes: 20 },
    [MutationOpcode.RemoveNode]: { fixedBytes: 8, minimumBytes: 8 },
    [MutationOpcode.Reparent]: { fixedBytes: 16, minimumBytes: 16 },
    [MutationOpcode.SetF32]: { fixedBytes: 16, minimumBytes: 16 },
    [MutationOpcode.SetVec4]: { fixedBytes: 28, minimumBytes: 28 },
    [MutationOpcode.SetRef]: { fixedBytes: 16, minimumBytes: 16 },
    [MutationOpcode.SetFlags]: { fixedBytes: 16, minimumBytes: 16 },
    [MutationOpcode.ClearProp]: { fixedBytes: 12, minimumBytes: 12 },
    [MutationOpcode.SetTextRun]: { fixedBytes: 16, minimumBytes: 16 },
    [MutationOpcode.SetRichText]: { fixedBytes: 20, minimumBytes: 20 },
    [MutationOpcode.DefineResource]: { fixedBytes: null, minimumBytes: 16 },
    [MutationOpcode.ReleaseResource]: { fixedBytes: 8, minimumBytes: 8 },
    [MutationOpcode.ScrollTo]: { fixedBytes: 20, minimumBytes: 20 },
    [MutationOpcode.ConfigureVirtualList]: { fixedBytes: 32, minimumBytes: 32 },
    [MutationOpcode.SetVirtualItem]: { fixedBytes: 12, minimumBytes: 12 },
    [MutationOpcode.ConfigureEditable]: { fixedBytes: 24, minimumBytes: 24 },
    [MutationOpcode.ConfigureDocument]: { fixedBytes: null, minimumBytes: 24 },
    [MutationOpcode.ObserveGeometry]: { fixedBytes: 12, minimumBytes: 12 },
    [MutationOpcode.Commit]: { fixedBytes: 8, minimumBytes: 8 },
};
export var InputOpcode;
(function (InputOpcode) {
    InputOpcode[InputOpcode["Replace"] = 1] = "Replace";
    InputOpcode[InputOpcode["Insert"] = 2] = "Insert";
    InputOpcode[InputOpcode["DeleteBackward"] = 3] = "DeleteBackward";
    InputOpcode[InputOpcode["DeleteForward"] = 4] = "DeleteForward";
    InputOpcode[InputOpcode["SetSelection"] = 5] = "SetSelection";
    InputOpcode[InputOpcode["BeginComposition"] = 6] = "BeginComposition";
    InputOpcode[InputOpcode["UpdateComposition"] = 7] = "UpdateComposition";
    InputOpcode[InputOpcode["CommitComposition"] = 8] = "CommitComposition";
    InputOpcode[InputOpcode["CancelComposition"] = 9] = "CancelComposition";
    InputOpcode[InputOpcode["Undo"] = 10] = "Undo";
    InputOpcode[InputOpcode["Redo"] = 11] = "Redo";
    InputOpcode[InputOpcode["FocusEditable"] = 12] = "FocusEditable";
    InputOpcode[InputOpcode["BlurEditable"] = 13] = "BlurEditable";
    InputOpcode[InputOpcode["RequestCharacterBounds"] = 14] = "RequestCharacterBounds";
    InputOpcode[InputOpcode["PlaceCaret"] = 15] = "PlaceCaret";
    InputOpcode[InputOpcode["SetWordBoundaries"] = 17] = "SetWordBoundaries";
    InputOpcode[InputOpcode["SetMarks"] = 18] = "SetMarks";
    InputOpcode[InputOpcode["SetPendingMark"] = 19] = "SetPendingMark";
    InputOpcode[InputOpcode["BreakUndoGroup"] = 20] = "BreakUndoGroup";
    InputOpcode[InputOpcode["MoveCaret"] = 16] = "MoveCaret";
    InputOpcode[InputOpcode["SetDocumentSelection"] = 21] = "SetDocumentSelection";
    InputOpcode[InputOpcode["MoveDocumentCaret"] = 22] = "MoveDocumentCaret";
    InputOpcode[InputOpcode["EditDocument"] = 23] = "EditDocument";
    InputOpcode[InputOpcode["ScrollBegin"] = 32] = "ScrollBegin";
    InputOpcode[InputOpcode["ScrollDelta"] = 33] = "ScrollDelta";
    InputOpcode[InputOpcode["ScrollEnd"] = 34] = "ScrollEnd";
    InputOpcode[InputOpcode["ScrollCancel"] = 35] = "ScrollCancel";
    InputOpcode[InputOpcode["SetScrollVelocity"] = 36] = "SetScrollVelocity";
    InputOpcode[InputOpcode["ScrollTo"] = 37] = "ScrollTo";
    InputOpcode[InputOpcode["ScrollBy"] = 38] = "ScrollBy";
    InputOpcode[InputOpcode["DispatchEvent"] = 48] = "DispatchEvent";
    InputOpcode[InputOpcode["SetPointerCapture"] = 49] = "SetPointerCapture";
    InputOpcode[InputOpcode["ReleasePointerCapture"] = 50] = "ReleasePointerCapture";
    InputOpcode[InputOpcode["FocusNode"] = 51] = "FocusNode";
    InputOpcode[InputOpcode["BlurNode"] = 52] = "BlurNode";
    InputOpcode[InputOpcode["ResetInteraction"] = 53] = "ResetInteraction";
    InputOpcode[InputOpcode["DispatchKeyEvent"] = 54] = "DispatchKeyEvent";
    InputOpcode[InputOpcode["Commit"] = 240] = "Commit";
})(InputOpcode || (InputOpcode = {}));
export const INPUT_LAYOUTS = {
    [InputOpcode.Replace]: { fixedBytes: null, minimumBytes: 28 },
    [InputOpcode.Insert]: { fixedBytes: null, minimumBytes: 20 },
    [InputOpcode.DeleteBackward]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.DeleteForward]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.SetSelection]: { fixedBytes: 28, minimumBytes: 28 },
    [InputOpcode.BeginComposition]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.UpdateComposition]: { fixedBytes: null, minimumBytes: 20 },
    [InputOpcode.CommitComposition]: { fixedBytes: null, minimumBytes: 24 },
    [InputOpcode.CancelComposition]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.Undo]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.Redo]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.FocusEditable]: { fixedBytes: 8, minimumBytes: 8 },
    [InputOpcode.BlurEditable]: { fixedBytes: 8, minimumBytes: 8 },
    [InputOpcode.RequestCharacterBounds]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.PlaceCaret]: { fixedBytes: 20, minimumBytes: 20 },
    [InputOpcode.SetWordBoundaries]: { fixedBytes: null, minimumBytes: 20 },
    [InputOpcode.SetMarks]: { fixedBytes: 32, minimumBytes: 32 },
    [InputOpcode.SetPendingMark]: { fixedBytes: 28, minimumBytes: 28 },
    [InputOpcode.BreakUndoGroup]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.MoveCaret]: { fixedBytes: 12, minimumBytes: 12 },
    [InputOpcode.SetDocumentSelection]: { fixedBytes: 40, minimumBytes: 40 },
    [InputOpcode.MoveDocumentCaret]: { fixedBytes: 12, minimumBytes: 12 },
    [InputOpcode.EditDocument]: { fixedBytes: null, minimumBytes: 32 },
    [InputOpcode.ScrollBegin]: { fixedBytes: 8, minimumBytes: 8 },
    [InputOpcode.ScrollDelta]: { fixedBytes: 20, minimumBytes: 20 },
    [InputOpcode.ScrollEnd]: { fixedBytes: 8, minimumBytes: 8 },
    [InputOpcode.ScrollCancel]: { fixedBytes: 8, minimumBytes: 8 },
    [InputOpcode.SetScrollVelocity]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.ScrollTo]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.ScrollBy]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.DispatchEvent]: { fixedBytes: 68, minimumBytes: 68 },
    [InputOpcode.SetPointerCapture]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.ReleasePointerCapture]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.FocusNode]: { fixedBytes: 16, minimumBytes: 16 },
    [InputOpcode.BlurNode]: { fixedBytes: 12, minimumBytes: 12 },
    [InputOpcode.ResetInteraction]: { fixedBytes: 12, minimumBytes: 12 },
    [InputOpcode.DispatchKeyEvent]: { fixedBytes: 28, minimumBytes: 28 },
    [InputOpcode.Commit]: { fixedBytes: 8, minimumBytes: 8 },
};
export var DisplayOpcode;
(function (DisplayOpcode) {
    DisplayOpcode[DisplayOpcode["Save"] = 1] = "Save";
    DisplayOpcode[DisplayOpcode["Restore"] = 2] = "Restore";
    DisplayOpcode[DisplayOpcode["Transform"] = 3] = "Transform";
    DisplayOpcode[DisplayOpcode["ClipRect"] = 4] = "ClipRect";
    DisplayOpcode[DisplayOpcode["Alpha"] = 5] = "Alpha";
    DisplayOpcode[DisplayOpcode["FillRect"] = 16] = "FillRect";
    DisplayOpcode[DisplayOpcode["FillRRect"] = 17] = "FillRRect";
    DisplayOpcode[DisplayOpcode["FillPath"] = 18] = "FillPath";
    DisplayOpcode[DisplayOpcode["StrokePath"] = 19] = "StrokePath";
    DisplayOpcode[DisplayOpcode["DrawGlyphRun"] = 32] = "DrawGlyphRun";
    DisplayOpcode[DisplayOpcode["DrawTextFallback"] = 33] = "DrawTextFallback";
    DisplayOpcode[DisplayOpcode["DrawTextInlineFallback"] = 36] = "DrawTextInlineFallback";
    DisplayOpcode[DisplayOpcode["FillPlaceholder"] = 38] = "FillPlaceholder";
    DisplayOpcode[DisplayOpcode["FillColorRect"] = 39] = "FillColorRect";
    DisplayOpcode[DisplayOpcode["FillColorRRect"] = 40] = "FillColorRRect";
    DisplayOpcode[DisplayOpcode["FillColorBorder"] = 41] = "FillColorBorder";
    DisplayOpcode[DisplayOpcode["DrawEditorDecoration"] = 37] = "DrawEditorDecoration";
    DisplayOpcode[DisplayOpcode["FillColorShadow"] = 42] = "FillColorShadow";
    DisplayOpcode[DisplayOpcode["FillColorPath"] = 43] = "FillColorPath";
    DisplayOpcode[DisplayOpcode["StrokeColorPath"] = 44] = "StrokeColorPath";
    DisplayOpcode[DisplayOpcode["DrawImage"] = 34] = "DrawImage";
    DisplayOpcode[DisplayOpcode["DrawPicture"] = 35] = "DrawPicture";
})(DisplayOpcode || (DisplayOpcode = {}));
export const DISPLAY_LAYOUTS = {
    [DisplayOpcode.Save]: { fixedBytes: 4, minimumBytes: 4 },
    [DisplayOpcode.Restore]: { fixedBytes: 4, minimumBytes: 4 },
    [DisplayOpcode.Transform]: { fixedBytes: 28, minimumBytes: 28 },
    [DisplayOpcode.ClipRect]: { fixedBytes: 20, minimumBytes: 20 },
    [DisplayOpcode.Alpha]: { fixedBytes: 8, minimumBytes: 8 },
    [DisplayOpcode.FillRect]: { fixedBytes: 24, minimumBytes: 24 },
    [DisplayOpcode.FillRRect]: { fixedBytes: 40, minimumBytes: 40 },
    [DisplayOpcode.FillPath]: { fixedBytes: 12, minimumBytes: 12 },
    [DisplayOpcode.StrokePath]: { fixedBytes: 24, minimumBytes: 24 },
    [DisplayOpcode.DrawGlyphRun]: { fixedBytes: 24, minimumBytes: 24 },
    [DisplayOpcode.DrawTextFallback]: { fixedBytes: 20, minimumBytes: 20 },
    [DisplayOpcode.DrawTextInlineFallback]: { fixedBytes: null, minimumBytes: 20 },
    [DisplayOpcode.FillPlaceholder]: { fixedBytes: 24, minimumBytes: 24 },
    [DisplayOpcode.FillColorRect]: { fixedBytes: 24, minimumBytes: 24 },
    [DisplayOpcode.FillColorRRect]: { fixedBytes: 40, minimumBytes: 40 },
    [DisplayOpcode.FillColorBorder]: { fixedBytes: 68, minimumBytes: 68 },
    [DisplayOpcode.DrawEditorDecoration]: { fixedBytes: 28, minimumBytes: 28 },
    [DisplayOpcode.FillColorShadow]: { fixedBytes: 52, minimumBytes: 52 },
    [DisplayOpcode.FillColorPath]: { fixedBytes: 12, minimumBytes: 12 },
    [DisplayOpcode.StrokeColorPath]: { fixedBytes: 24, minimumBytes: 24 },
    [DisplayOpcode.DrawImage]: { fixedBytes: 40, minimumBytes: 40 },
    [DisplayOpcode.DrawPicture]: { fixedBytes: 16, minimumBytes: 16 },
};
export var GlyphResourceOpcode;
(function (GlyphResourceOpcode) {
    GlyphResourceOpcode[GlyphResourceOpcode["DefineGlyphSpan"] = 1] = "DefineGlyphSpan";
    GlyphResourceOpcode[GlyphResourceOpcode["ReleaseGlyphSpan"] = 2] = "ReleaseGlyphSpan";
})(GlyphResourceOpcode || (GlyphResourceOpcode = {}));
export const GLYPH_RESOURCE_LAYOUTS = {
    [GlyphResourceOpcode.DefineGlyphSpan]: { fixedBytes: null, minimumBytes: 24 },
    [GlyphResourceOpcode.ReleaseGlyphSpan]: { fixedBytes: 8, minimumBytes: 8 },
};
export var SystemTextMetricOpcode;
(function (SystemTextMetricOpcode) {
    SystemTextMetricOpcode[SystemTextMetricOpcode["UpsertSystemTextMetric"] = 1] = "UpsertSystemTextMetric";
    SystemTextMetricOpcode[SystemTextMetricOpcode["ReleaseSystemTextMetric"] = 2] = "ReleaseSystemTextMetric";
})(SystemTextMetricOpcode || (SystemTextMetricOpcode = {}));
export const SYSTEM_TEXT_METRIC_LAYOUTS = {
    [SystemTextMetricOpcode.UpsertSystemTextMetric]: { fixedBytes: null, minimumBytes: 32 },
    [SystemTextMetricOpcode.ReleaseSystemTextMetric]: { fixedBytes: 12, minimumBytes: 12 },
};
export var NodeKind;
(function (NodeKind) {
    NodeKind[NodeKind["Root"] = 1] = "Root";
    NodeKind[NodeKind["Container"] = 2] = "Container";
    NodeKind[NodeKind["Text"] = 3] = "Text";
    NodeKind[NodeKind["Image"] = 4] = "Image";
    NodeKind[NodeKind["EditableText"] = 5] = "EditableText";
    NodeKind[NodeKind["Scroll"] = 6] = "Scroll";
    NodeKind[NodeKind["Video"] = 7] = "Video";
})(NodeKind || (NodeKind = {}));
export var ResourceKind;
(function (ResourceKind) {
    ResourceKind[ResourceKind["Utf8String"] = 1] = "Utf8String";
    ResourceKind[ResourceKind["Image"] = 2] = "Image";
    ResourceKind[ResourceKind["Path"] = 3] = "Path";
    ResourceKind[ResourceKind["Font"] = 4] = "Font";
    ResourceKind[ResourceKind["GlyphSpan"] = 5] = "GlyphSpan";
    ResourceKind[ResourceKind["Paint"] = 6] = "Paint";
    ResourceKind[ResourceKind["TextStyle"] = 7] = "TextStyle";
    ResourceKind[ResourceKind["Affine"] = 8] = "Affine";
    ResourceKind[ResourceKind["ComputedStyle"] = 9] = "ComputedStyle";
    ResourceKind[ResourceKind["Animation"] = 10] = "Animation";
    ResourceKind[ResourceKind["VideoFrame"] = 11] = "VideoFrame";
    ResourceKind[ResourceKind["StyledRuns"] = 12] = "StyledRuns";
})(ResourceKind || (ResourceKind = {}));
export var Prop;
(function (Prop) {
    Prop[Prop["Width"] = 1] = "Width";
    Prop[Prop["Height"] = 2] = "Height";
    Prop[Prop["MinWidth"] = 3] = "MinWidth";
    Prop[Prop["MinHeight"] = 4] = "MinHeight";
    Prop[Prop["MaxWidth"] = 5] = "MaxWidth";
    Prop[Prop["MaxHeight"] = 6] = "MaxHeight";
    Prop[Prop["Padding"] = 7] = "Padding";
    Prop[Prop["Direction"] = 8] = "Direction";
    Prop[Prop["Gap"] = 9] = "Gap";
    Prop[Prop["Color"] = 16] = "Color";
    Prop[Prop["BackgroundColor"] = 17] = "BackgroundColor";
    Prop[Prop["Opacity"] = 18] = "Opacity";
    Prop[Prop["Transform"] = 19] = "Transform";
    Prop[Prop["Text"] = 32] = "Text";
    Prop[Prop["FontSize"] = 33] = "FontSize";
    Prop[Prop["Font"] = 34] = "Font";
    Prop[Prop["Image"] = 35] = "Image";
    Prop[Prop["PathStrokeWidth"] = 38] = "PathStrokeWidth";
    Prop[Prop["Path"] = 37] = "Path";
    Prop[Prop["VideoFrame"] = 36] = "VideoFrame";
    Prop[Prop["OnTap"] = 48] = "OnTap";
    Prop[Prop["SemanticRole"] = 64] = "SemanticRole";
    Prop[Prop["SemanticLabel"] = 65] = "SemanticLabel";
    Prop[Prop["SemanticValue"] = 66] = "SemanticValue";
    Prop[Prop["ComputedStyle"] = 80] = "ComputedStyle";
    Prop[Prop["Animation"] = 81] = "Animation";
})(Prop || (Prop = {}));
export var Invalidation;
(function (Invalidation) {
    Invalidation[Invalidation["None"] = 0] = "None";
    Invalidation[Invalidation["Layout"] = 1] = "Layout";
    Invalidation[Invalidation["Paint"] = 2] = "Paint";
    Invalidation[Invalidation["PaintSelf"] = 4] = "PaintSelf";
    Invalidation[Invalidation["Hit"] = 8] = "Hit";
    Invalidation[Invalidation["Semantics"] = 16] = "Semantics";
    Invalidation[Invalidation["Scroll"] = 32] = "Scroll";
})(Invalidation || (Invalidation = {}));
export const PROP_METADATA = {
    1: { name: "Width", valueType: "f32", resourceKind: null, invalidation: 3 },
    2: { name: "Height", valueType: "f32", resourceKind: null, invalidation: 3 },
    3: { name: "MinWidth", valueType: "f32", resourceKind: null, invalidation: 3 },
    4: { name: "MinHeight", valueType: "f32", resourceKind: null, invalidation: 3 },
    5: { name: "MaxWidth", valueType: "f32", resourceKind: null, invalidation: 3 },
    6: { name: "MaxHeight", valueType: "f32", resourceKind: null, invalidation: 3 },
    7: { name: "Padding", valueType: "vec4", resourceKind: null, invalidation: 3 },
    8: { name: "Direction", valueType: "f32", resourceKind: null, invalidation: 3 },
    9: { name: "Gap", valueType: "f32", resourceKind: null, invalidation: 3 },
    16: { name: "Color", valueType: "ref", resourceKind: ResourceKind.Paint, invalidation: 2 },
    17: {
        name: "BackgroundColor",
        valueType: "ref",
        resourceKind: ResourceKind.Paint,
        invalidation: 2,
    },
    18: { name: "Opacity", valueType: "f32", resourceKind: null, invalidation: 4 },
    19: { name: "Transform", valueType: "ref", resourceKind: ResourceKind.Affine, invalidation: 10 },
    32: { name: "Text", valueType: "ref", resourceKind: ResourceKind.Utf8String, invalidation: 19 },
    33: { name: "FontSize", valueType: "f32", resourceKind: null, invalidation: 3 },
    34: { name: "Font", valueType: "ref", resourceKind: ResourceKind.Font, invalidation: 3 },
    35: { name: "Image", valueType: "ref", resourceKind: ResourceKind.Image, invalidation: 3 },
    38: { name: "PathStrokeWidth", valueType: "f32", resourceKind: null, invalidation: 2 },
    37: { name: "Path", valueType: "ref", resourceKind: ResourceKind.Path, invalidation: 2 },
    36: {
        name: "VideoFrame",
        valueType: "ref",
        resourceKind: ResourceKind.VideoFrame,
        invalidation: 3,
    },
    48: { name: "OnTap", valueType: "ref", resourceKind: null, invalidation: 0 },
    64: {
        name: "SemanticRole",
        valueType: "ref",
        resourceKind: ResourceKind.Utf8String,
        invalidation: 16,
    },
    65: {
        name: "SemanticLabel",
        valueType: "ref",
        resourceKind: ResourceKind.Utf8String,
        invalidation: 16,
    },
    66: {
        name: "SemanticValue",
        valueType: "ref",
        resourceKind: ResourceKind.Utf8String,
        invalidation: 16,
    },
    80: {
        name: "ComputedStyle",
        valueType: "ref",
        resourceKind: ResourceKind.ComputedStyle,
        invalidation: 63,
    },
    81: {
        name: "Animation",
        valueType: "ref",
        resourceKind: ResourceKind.Animation,
        invalidation: 12,
    },
};
export const KEYBOARD_CODES = [
    "KeyA",
    "KeyB",
    "KeyC",
    "KeyD",
    "KeyE",
    "KeyF",
    "KeyG",
    "KeyH",
    "KeyI",
    "KeyJ",
    "KeyK",
    "KeyL",
    "KeyM",
    "KeyN",
    "KeyO",
    "KeyP",
    "KeyQ",
    "KeyR",
    "KeyS",
    "KeyT",
    "KeyU",
    "KeyV",
    "KeyW",
    "KeyX",
    "KeyY",
    "KeyZ",
    "Digit0",
    "Digit1",
    "Digit2",
    "Digit3",
    "Digit4",
    "Digit5",
    "Digit6",
    "Digit7",
    "Digit8",
    "Digit9",
    "Enter",
    "Tab",
    "Space",
    "Backspace",
    "Delete",
    "Escape",
    "Insert",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
    "PageUp",
    "PageDown",
    "ShiftLeft",
    "ShiftRight",
    "ControlLeft",
    "ControlRight",
    "AltLeft",
    "AltRight",
    "MetaLeft",
    "MetaRight",
    "CapsLock",
    "NumLock",
    "ScrollLock",
    "ContextMenu",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "F10",
    "F11",
    "F12",
    "Backquote",
    "Minus",
    "Equal",
    "BracketLeft",
    "BracketRight",
    "Backslash",
    "Semicolon",
    "Quote",
    "Comma",
    "Period",
    "Slash",
    "IntlBackslash",
    "IntlRo",
    "IntlYen",
    "Numpad0",
    "Numpad1",
    "Numpad2",
    "Numpad3",
    "Numpad4",
    "Numpad5",
    "Numpad6",
    "Numpad7",
    "Numpad8",
    "Numpad9",
    "NumpadAdd",
    "NumpadSubtract",
    "NumpadMultiply",
    "NumpadDivide",
    "NumpadDecimal",
    "NumpadEnter",
    "NumpadEqual",
    "NumpadComma",
    "PrintScreen",
    "Pause",
];
export const KEYBOARD_CODES_BY_NAME = new Map(KEYBOARD_CODES.map((entry, index) => [entry, index + 1]));
export const KEYBOARD_KEY_NAMES = [
    "Enter",
    "Tab",
    "Backspace",
    "Delete",
    "Escape",
    "Insert",
    "Clear",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
    "PageUp",
    "PageDown",
    "Shift",
    "Control",
    "Alt",
    "Meta",
    "AltGraph",
    "CapsLock",
    "NumLock",
    "ScrollLock",
    "ContextMenu",
    "Fn",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "F10",
    "F11",
    "F12",
    "Copy",
    "Cut",
    "Paste",
    "Undo",
    "Redo",
    "Help",
    "Print",
    "PrintScreen",
    "Pause",
    "ZoomIn",
    "ZoomOut",
    "Process",
    "Dead",
    "Unidentified",
];
export const KEYBOARD_KEY_NAMES_BY_NAME = new Map(KEYBOARD_KEY_NAMES.map((entry, index) => [entry, index + 1]));
export const PICTURE_RESOURCES_MAGIC = 1347440452;
export const MAX_PICTURE_RESOURCES_BYTES = 16777216;
export const MAX_PICTURE_RESOURCE_INSTRUCTIONS = 262144;
export const MAX_PICTURE_RESIDENT_BYTES = 16777216;
export var PictureResourceOpcode;
(function (PictureResourceOpcode) {
    PictureResourceOpcode[PictureResourceOpcode["DefinePicture"] = 1] = "DefinePicture";
    PictureResourceOpcode[PictureResourceOpcode["ReleasePicture"] = 2] = "ReleasePicture";
})(PictureResourceOpcode || (PictureResourceOpcode = {}));
export const PICTURE_RESOURCE_LAYOUTS = {
    [PictureResourceOpcode.DefinePicture]: { fixedBytes: null, minimumBytes: 12 },
    [PictureResourceOpcode.ReleasePicture]: { fixedBytes: 8, minimumBytes: 8 },
};
export const NON_PASSIVE_REGION_VERSION = 1;
export const NON_PASSIVE_REGION_HEADER_WORDS = 2;
export const NON_PASSIVE_REGION_RECORD_WORDS = 5;
export const NON_PASSIVE_REGION_HEADER_VERSION_INDEX = 0;
export const NON_PASSIVE_REGION_HEADER_REGION_COUNT_INDEX = 1;
export const NON_PASSIVE_REGION_RECORD_FLAGS_INDEX = 0;
export const NON_PASSIVE_REGION_RECORD_LEFT_BITS_INDEX = 1;
export const NON_PASSIVE_REGION_RECORD_TOP_BITS_INDEX = 2;
export const NON_PASSIVE_REGION_RECORD_RIGHT_BITS_INDEX = 3;
export const NON_PASSIVE_REGION_RECORD_BOTTOM_BITS_INDEX = 4;
export const EDITING_GEOMETRY_VERSION = 1;
export const EDITING_GEOMETRY_HEADER_WORDS = 5;
export const EDITING_GEOMETRY_RECT_WORDS = 4;
export const EDITING_GEOMETRY_CHARACTER_WORDS = 6;
export const EDITING_GEOMETRY_HEADER_VERSION_INDEX = 0;
export const EDITING_GEOMETRY_HEADER_NODE_ID_INDEX = 1;
export const EDITING_GEOMETRY_HEADER_SELECTION_START_INDEX = 2;
export const EDITING_GEOMETRY_HEADER_SELECTION_END_INDEX = 3;
export const EDITING_GEOMETRY_HEADER_CHARACTER_COUNT_INDEX = 4;
export const EDITING_GEOMETRY_RECT_LEFT_BITS_INDEX = 0;
export const EDITING_GEOMETRY_RECT_TOP_BITS_INDEX = 1;
export const EDITING_GEOMETRY_RECT_WIDTH_BITS_INDEX = 2;
export const EDITING_GEOMETRY_RECT_HEIGHT_BITS_INDEX = 3;
export const EDITING_GEOMETRY_CHARACTER_START_INDEX = 0;
export const EDITING_GEOMETRY_CHARACTER_END_INDEX = 1;
export const EDITING_GEOMETRY_CHARACTER_LEFT_BITS_INDEX = 2;
export const EDITING_GEOMETRY_CHARACTER_TOP_BITS_INDEX = 3;
export const EDITING_GEOMETRY_CHARACTER_WIDTH_BITS_INDEX = 4;
export const EDITING_GEOMETRY_CHARACTER_HEIGHT_BITS_INDEX = 5;
export const SEMANTICS_VERSION = 1;
export const SEMANTICS_HEADER_WORDS = 2;
export const SEMANTICS_RECORD_WORDS = 9;
export const SEMANTICS_HEADER_VERSION_INDEX = 0;
export const SEMANTICS_HEADER_NODE_COUNT_INDEX = 1;
export const SEMANTICS_RECORD_NODE_ID_INDEX = 0;
export const SEMANTICS_RECORD_FLAGS_INDEX = 1;
export const SEMANTICS_RECORD_LEFT_BITS_INDEX = 2;
export const SEMANTICS_RECORD_TOP_BITS_INDEX = 3;
export const SEMANTICS_RECORD_WIDTH_BITS_INDEX = 4;
export const SEMANTICS_RECORD_HEIGHT_BITS_INDEX = 5;
export const SEMANTICS_RECORD_ROLE_BYTES_INDEX = 6;
export const SEMANTICS_RECORD_LABEL_BYTES_INDEX = 7;
export const SEMANTICS_RECORD_VALUE_BYTES_INDEX = 8;
export const PAINTED_TEXT_VERSION = 1;
export const PAINTED_TEXT_HEADER_WORDS = 3;
export const PAINTED_TEXT_RECORD_WORDS = 5;
export const PAINTED_TEXT_HEADER_VERSION_INDEX = 0;
export const PAINTED_TEXT_HEADER_FLAGS_INDEX = 1;
export const PAINTED_TEXT_HEADER_RECORD_COUNT_INDEX = 2;
export const PAINTED_TEXT_RECORD_NODE_ID_INDEX = 0;
export const PAINTED_TEXT_RECORD_FLAGS_INDEX = 1;
export const PAINTED_TEXT_RECORD_X_BITS_INDEX = 2;
export const PAINTED_TEXT_RECORD_Y_BITS_INDEX = 3;
export const PAINTED_TEXT_RECORD_TEXT_BYTES_INDEX = 4;
export const PAINTED_TEXT_CHANNEL_MASK = 3;
export const PAINTED_TEXT_CHANNEL_SHAPED_RUN = 0;
export const PAINTED_TEXT_CHANNEL_SYSTEM_FALLBACK = 1;
export const PAINTED_TEXT_CHANNEL_INLINE_FALLBACK = 2;
export const PAINTED_TEXT_FLAG_ORIGIN_CLIPPED = 4;
export const PAINTED_TEXT_FLAG_UNATTRIBUTED = 8;
export const PAINTED_TEXT_HEADER_FLAG_TRUNCATED = 1;
export const LAYOUT_GEOMETRY_VERSION = 1;
export const LAYOUT_GEOMETRY_HEADER_WORDS = 3;
export const LAYOUT_GEOMETRY_RECORD_WORDS = 10;
export const LAYOUT_GEOMETRY_HEADER_VERSION_INDEX = 0;
export const LAYOUT_GEOMETRY_HEADER_FRAME_SEQ_INDEX = 1;
export const LAYOUT_GEOMETRY_HEADER_RECORD_COUNT_INDEX = 2;
export const LAYOUT_GEOMETRY_RECORD_NODE_ID_INDEX = 0;
export const LAYOUT_GEOMETRY_RECORD_FLAGS_INDEX = 1;
export const LAYOUT_GEOMETRY_RECORD_OWN_LEFT_BITS_INDEX = 2;
export const LAYOUT_GEOMETRY_RECORD_OWN_TOP_BITS_INDEX = 3;
export const LAYOUT_GEOMETRY_RECORD_OWN_WIDTH_BITS_INDEX = 4;
export const LAYOUT_GEOMETRY_RECORD_OWN_HEIGHT_BITS_INDEX = 5;
export const LAYOUT_GEOMETRY_RECORD_CLIP_LEFT_BITS_INDEX = 6;
export const LAYOUT_GEOMETRY_RECORD_CLIP_TOP_BITS_INDEX = 7;
export const LAYOUT_GEOMETRY_RECORD_CLIP_WIDTH_BITS_INDEX = 8;
export const LAYOUT_GEOMETRY_RECORD_CLIP_HEIGHT_BITS_INDEX = 9;
export const MAX_OBSERVED_GEOMETRY_NODES = 64;
export const EDIT_TRANSACTIONS_MAGIC = 1162891076;
export const MAX_EDIT_TRANSACTIONS_BYTES = 16777216;
export const MAX_EDIT_TRANSACTION_INSTRUCTIONS = 262144;
export var EditTransactionOpcode;
(function (EditTransactionOpcode) {
    EditTransactionOpcode[EditTransactionOpcode["DocumentSelection"] = 3] = "DocumentSelection";
    EditTransactionOpcode[EditTransactionOpcode["Structure"] = 2] = "Structure";
    EditTransactionOpcode[EditTransactionOpcode["Transaction"] = 1] = "Transaction";
})(EditTransactionOpcode || (EditTransactionOpcode = {}));
export const EDIT_TRANSACTION_LAYOUTS = {
    [EditTransactionOpcode.DocumentSelection]: { fixedBytes: 32, minimumBytes: 32 },
    [EditTransactionOpcode.Structure]: { fixedBytes: null, minimumBytes: 32 },
    [EditTransactionOpcode.Transaction]: { fixedBytes: null, minimumBytes: 64 },
};
export const EVENT_TRANSACTIONS_MAGIC = 1448103748;
export const MAX_EVENT_TRANSACTIONS_BYTES = 16777216;
export const MAX_EVENT_TRANSACTION_INSTRUCTIONS = 262144;
export var EventTransactionOpcode;
(function (EventTransactionOpcode) {
    EventTransactionOpcode[EventTransactionOpcode["Event"] = 1] = "Event";
})(EventTransactionOpcode || (EventTransactionOpcode = {}));
export const EVENT_TRANSACTION_LAYOUTS = {
    [EventTransactionOpcode.Event]: { fixedBytes: null, minimumBytes: 92 },
};
//# sourceMappingURL=generated.js.map